/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './c3-js-demo.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../../src/app/shared/panel/panel.component';
import * as i4 from '../../shared/c3js-chart/c3js-chart.component.ngfactory';
import * as i5 from '../../../../../src/app/shared/c3js-chart/c3js-chart.component';
import * as i6 from '../../shared/grid/grid.component.ngfactory';
import * as i7 from '../../../../../src/app/shared/grid/grid.component';
import * as i8 from '@angular/common';
import * as i9 from '../../../../../src/app/chart/c3-js/c3-js-demo.component';
const styles_C3JSDemoComponent:any[] = [i0.styles];
export const RenderType_C3JSDemoComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_C3JSDemoComponent,data:{}});
function View_C3JSDemoComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'h3',[['class','header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵeld(0,(null as any),1,1,
          'admin-c3js-chart',([] as any[]),(null as any),(null as any),(null as any),
          i4.View_C3JSChartComponent_0,i4.RenderType_C3JSChartComponent)),i1.ɵdid(4898816,
          (null as any),0,i5.C3JSChartComponent,([] as any[]),{columns:[0,'columns'],
              type:[1,'type'],group:[2,'group'],x:[3,'x']},(null as any))],(_ck,_v) => {
    const currVal_4:any = (<any>_v.parent).context.$implicit.columns;
    const currVal_5:any = (<any>_v.parent).context.$implicit.type;
    const currVal_6:boolean = !!(<any>_v.parent).context.$implicit.group;
    const currVal_7:any = (<any>_v.parent).context.$implicit.x;
    _ck(_v,5,0,currVal_4,currVal_5,currVal_6,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.$implicit.header;
    _ck(_v,3,0,currVal_3);
  });
}
function View_C3JSDemoComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),(null as any),(null as any)),
      i1.ɵqud(603979776,1,{templates:1}),(_l()(),i1.ɵand(0,[[1,2]],(null as any),0,
          (null as any),View_C3JSDemoComponent_2))],(null as any),(null as any));
}
function View_C3JSDemoComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,1,'h3',[['class','header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Gauge'])),(_l()(),i1.ɵeld(0,(null as any),1,
          2,'admin-c3js-chart',[['type','gauge']],(null as any),(null as any),(null as any),
          i4.View_C3JSChartComponent_0,i4.RenderType_C3JSChartComponent)),i1.ɵdid(4898816,
          (null as any),0,i5.C3JSChartComponent,([] as any[]),{columns:[0,'columns'],
              type:[1,'type']},(null as any)),i1.ɵpad(2)],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = _ck(_v,6,0,'data',_co.gauge);
    const currVal_4:any = 'gauge';
    _ck(_v,5,0,currVal_3,currVal_4);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_C3JSDemoComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_C3JSDemoComponent_1)),i1.ɵdid(802816,(null as any),0,i8.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),3,'admin-grid',([] as any[]),(null as any),
          (null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),(null as any),(null as any)),
      i1.ɵqud(603979776,2,{templates:1}),(_l()(),i1.ɵand(0,[[2,2]],(null as any),0,
          (null as any),View_C3JSDemoComponent_3))],(_ck,_v) => {
    var _co:i9.C3JSDemoComponent = _v.component;
    const currVal_0:any = _co.charts;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_C3JSDemoComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_C3JSDemoComponent_0,
      RenderType_C3JSDemoComponent)),i1.ɵdid(245760,(null as any),0,i9.C3JSDemoComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const C3JSDemoComponentNgFactory:i1.ComponentFactory<i9.C3JSDemoComponent> = i1.ɵccf('ng-component',
    i9.C3JSDemoComponent,View_C3JSDemoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvYzMtanMvYzMtanMtZGVtby5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9jaGFydC9jMy1qcy9jMy1qcy1kZW1vLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvYzMtanMvYzMtanMtZGVtby5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvYzMtanMvYzMtanMtZGVtby5jb21wb25lbnQudHMuQzNKU0RlbW9Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YWRtaW4tZ3JpZCAqbmdGb3I9XCJsZXQgY2hhcnQgb2YgY2hhcnRzXCI+PG5nLXRlbXBsYXRlPjxhZG1pbi1wYW5lbD48aDMgY2xhc3M9XCJoZWFkZXJcIj57e2NoYXJ0LmhlYWRlcn19PC9oMz48YWRtaW4tYzNqcy1jaGFydCBbY29sdW1uc109XCJjaGFydC5jb2x1bW5zXCIgW3R5cGVdPVwiY2hhcnQudHlwZVwiIFtncm91cF09XCIhIWNoYXJ0Lmdyb3VwXCIgW3hdPVwiY2hhcnQueFwiPjwvYWRtaW4tYzNqcy1jaGFydD48L2FkbWluLXBhbmVsPjwvbmctdGVtcGxhdGU+PC9hZG1pbi1ncmlkPjxhZG1pbi1ncmlkPjxuZy10ZW1wbGF0ZT48YWRtaW4tcGFuZWw+PGgzIGNsYXNzPVwiaGVhZGVyXCI+R2F1Z2U8L2gzPjxhZG1pbi1jM2pzLWNoYXJ0IFtjb2x1bW5zXT1cIlsnZGF0YScsIGdhdWdlXVwiIHR5cGU9XCJnYXVnZVwiPjwvYWRtaW4tYzNqcy1jaGFydD48L2FkbWluLXBhbmVsPjwvbmctdGVtcGxhdGU+PC9hZG1pbi1ncmlkPiIsIjxuZy1jb21wb25lbnQ+PC9uZy1jb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBc0Q7TUFBQTtVQUFBO2FBQUE7VUFBQSxlQUFhO1VBQUE7TUFBbUIsd0NBQXFCO1VBQUE7dUVBQUEsVUFBQTtVQUFBO2NBQUE7SUFBa0I7SUFBMEI7SUFBb0I7SUFBd0I7SUFBeEYsV0FBa0IsVUFBMEIsVUFBb0IsVUFBd0IsU0FBeEY7O0lBQXJEO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7SUFBZ0M7SUFBQTs7OztvQkFBdEY7TUFBQTthQUFBO2FBQUEsNEJBQXlDO1VBQUE7OztvQkFBNlA7TUFBQTtVQUFBO2FBQUE7VUFBQSxlQUFhO1VBQUE7TUFBbUIsMENBQVU7VUFBQTt1RUFBQSxVQUFBO1VBQUE7Y0FBQSx1Q0FBa0I7O0lBQUE7SUFBNEI7SUFBOUMsV0FBa0IsVUFBNEIsU0FBOUM7O0lBQTFDO0lBQUE7SUFBQTtJQUFBLFdBQUEsNkJBQUE7Ozs7b0JBQXRTO01BQUEsa0NBQUE7dUNBQUEseUNBQTZRO2FBQUE7VUFBQTthQUFBO2FBQUEsNEJBQVk7VUFBQTs7SUFBN1E7SUFBWixXQUFZLFNBQVo7Ozs7b0JDQUE7TUFBQTtrQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/chart/c3-js/c3-js-demo.component.ngfactory.ts